export default "__VITE_ASSET__CGemgwXJ__"